'use client';

import Wish from '@/components/Product/Wish';
import type { Product } from '@/components/Product/ProductCard';
import { useEffect, useRef, type ComponentProps, type MouseEvent } from 'react';
import type { BestsellerProductTrackingHandlers } from './bestsellerTracking';

type WishProps = ComponentProps<typeof Wish>;

interface BestsellerTrackedWishProps extends Omit<WishProps, 'data' | 'wished' | 'removed'> {
  data: Product;
  onCollect: BestsellerProductTrackingHandlers['onCollect'];
  onWishChange?: (isWish: number) => void;
}

export default function BestsellerTrackedWish({
  data,
  onCollect,
  onWishChange,
  ...wishProps
}: BestsellerTrackedWishProps) {
  const isWishRef = useRef(data.is_wish);

  useEffect(() => {
    isWishRef.current = data.is_wish;
  }, [data.id, data.is_wish, data.shop_sku]);

  const handleClickCapture = (event: MouseEvent<HTMLSpanElement>) => {
    if (!(event.target as HTMLElement).closest('button')) return;
    onCollect(isWishRef.current === 1 ? '取消收藏' : '收藏', data);
  };

  return (
    <span data-bestseller-collect-tracker onClickCapture={handleClickCapture}>
      <Wish
        {...wishProps}
        data={data}
        wished={() => {
          isWishRef.current = 1;
          onWishChange?.(1);
        }}
        removed={() => {
          isWishRef.current = 2;
          onWishChange?.(2);
        }}
      />
    </span>
  );
}
